import React from 'react';
import SecureComponent from '../SecureComponent';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { toMoney, toMoneyTyping } from 'library/moneyUtils';
import { TextField } from '@mui/material';

class DecimalInputInventoryAdjust extends SecureComponent {
    constructor(props) {
        super(props);
        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value, error: "" };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", error: "" };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value)//if store's value relative to this component change, update the state value
            this.setState({ value: newProps.value });
        else if (!newProps.value)//in case the store does not have any value for this component, just clear it
            this.setState({ value: "" });

        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: newProps.error });
    }

    onChange = (event) => {
        const value = event.target.value;
        const maskedStringValue = toMoneyTyping(value);
        const floatValue = parseFloat(maskedStringValue.replace(new RegExp(',', 'g'), ''));
        const min = parseFloat(this.props.min || 0);
        const max = parseFloat(this.props.max || 0);
        let finalFloatValue = floatValue;

        if (this.props.min !== undefined && floatValue <= min) {
            finalFloatValue = min
        }
        if (this.props.max !== undefined && floatValue >= max) {
            finalFloatValue = max;
        }

        const finalMaskedStringValue = toMoneyTyping(Math.round(finalFloatValue * 100 * 100) / 100);

        this.setState({ value: finalMaskedStringValue });
        this.updateStore(finalMaskedStringValue);
    }

    onBlur = (event) => {
        this.updateStore(event.target.value);
    }

    updateStore(value) {
        const error = this.validate(value);
        this.setState({ value, error });
        this.props.dispatch({ type: types.FORM_INPUT, value: value.replace(new RegExp(',', 'g'), ''), name: this.props.name });
        if (this.props.name == "ProductSaveUnitPrice") {
            this.props.dispatch({ type: types.FORM_INPUT, value: value.replace(new RegExp(',', 'g'), ''), name: "ProductSaveMemberUnitPrice" });
        }
        let splitedName = this.props.name.split('_');

        //po price stuff
        if (splitedName[0] == 'inventoryAdjust' && splitedName[1] == 'salePrice' && this.props.poPrice && value >= this.props.poPrice) {
            this.props.dispatch({ type: types.FORM_INPUT, value: ((value.replace(new RegExp(',', 'g'), '') - this.props.poPrice) / this.props.poPrice * 100).toFixed(2), name: "inventoryAdjust_markup_" + splitedName[2] });
            this.props.dispatch({ type: types.FORM_INPUT, value: ((value.replace(new RegExp(',', 'g'), '') - this.props.poPrice) / value.replace(new RegExp(',', 'g'), '') * 100).toFixed(2), name: "inventoryAdjust_margin_" + splitedName[2] });
        }
        if (splitedName[0] == 'inventoryAdjust' && splitedName[1] == 'markup' && this.props.poPrice) {
            this.props.dispatch({ type: types.FORM_INPUT, value: (this.props.poPrice * (value.replace(new RegExp(',', 'g'), '') / 100 + 1)).toFixed(2), name: "inventoryAdjust_salePrice_" + splitedName[2] });
            this.props.dispatch({ type: types.FORM_INPUT, value: (this.props.poPrice * (value.replace(new RegExp(',', 'g'), '') / 100 + 1)).toFixed(2), name: "inventoryAdjust_memberPrice_" + splitedName[2] });
            this.props.dispatch({ type: types.FORM_INPUT, value: (value.replace(new RegExp(',', 'g'), '') / (1 + value.replace(new RegExp(',', 'g'), '') / 100)).toFixed(2), name: "inventoryAdjust_margin_" + splitedName[2] });
        }
        if (splitedName[0] == 'inventoryAdjust' && splitedName[1] == 'margin' && this.props.poPrice) {
            this.props.dispatch({ type: types.FORM_INPUT, value: (this.props.poPrice / (1 - value.replace(new RegExp(',', 'g'), '') / 100)).toFixed(2), name: "inventoryAdjust_salePrice_" + splitedName[2] });
            this.props.dispatch({ type: types.FORM_INPUT, value: (this.props.poPrice / (1 - value.replace(new RegExp(',', 'g'), '') / 100)).toFixed(2), name: "inventoryAdjust_memberPrice_" + splitedName[2] });
            this.props.dispatch({ type: types.FORM_INPUT, value: (value.replace(new RegExp(',', 'g'), '') / (1 - value.replace(new RegExp(',', 'g'), '') / 100)).toFixed(2), name: "inventoryAdjust_markup_" + splitedName[2] });
        }

        //latest po price stuff
        if (splitedName[0] == 'inventoryAdjust' && splitedName[1] == 'salePrice' && this.props.latestPOPrice && value >= this.props.latestPOPrice) {
            this.props.dispatch({ type: types.FORM_INPUT, value: ((value.replace(new RegExp(',', 'g'), '') - this.props.latestPOPrice) / this.props.latestPOPrice * 100).toFixed(2), name: "inventoryAdjust_latestMarkup_" + splitedName[2] });
            this.props.dispatch({ type: types.FORM_INPUT, value: ((value.replace(new RegExp(',', 'g'), '') - this.props.latestPOPrice) / value.replace(new RegExp(',', 'g'), '') * 100).toFixed(2), name: "inventoryAdjust_latestMargin_" + splitedName[2] });
        }
        if (splitedName[0] == 'inventoryAdjust' && splitedName[1] == 'latestMarkup' && this.props.latestPOPrice) {
            this.props.dispatch({ type: types.FORM_INPUT, value: (this.props.latestPOPrice * (value.replace(new RegExp(',', 'g'), '') / 100 + 1)).toFixed(2), name: "inventoryAdjust_salePrice_" + splitedName[2] });
            this.props.dispatch({ type: types.FORM_INPUT, value: (this.props.latestPOPrice * (value.replace(new RegExp(',', 'g'), '') / 100 + 1)).toFixed(2), name: "inventoryAdjust_memberPrice_" + splitedName[2] });
            this.props.dispatch({ type: types.FORM_INPUT, value: (value.replace(new RegExp(',', 'g'), '') / (1 + value.replace(new RegExp(',', 'g'), '') / 100)).toFixed(2), name: "inventoryAdjust_latestMargin_" + splitedName[2] });
        }
        if (splitedName[0] == 'inventoryAdjust' && splitedName[1] == 'latestMargin' && this.props.latestPOPrice) {
            this.props.dispatch({ type: types.FORM_INPUT, value: (this.props.latestPOPrice / (1 - value.replace(new RegExp(',', 'g'), '') / 100)).toFixed(2), name: "inventoryAdjust_salePrice_" + splitedName[2] });
            this.props.dispatch({ type: types.FORM_INPUT, value: (this.props.latestPOPrice / (1 - value.replace(new RegExp(',', 'g'), '') / 100)).toFixed(2), name: "inventoryAdjust_memberPrice_" + splitedName[2] });
            this.props.dispatch({ type: types.FORM_INPUT, value: (value.replace(new RegExp(',', 'g'), '') / (1 - value.replace(new RegExp(',', 'g'), '') / 100)).toFixed(2), name: "inventoryAdjust_latestMarkup_" + splitedName[2] });
        }

        //member price stuff
        if (splitedName[0] == 'inventoryAdjust' && splitedName[1] == 'salePrice') {
            this.props.dispatch({ type: types.FORM_INPUT, value: value.replace(new RegExp(',', 'g'), ''), name: "inventoryAdjust_memberPrice_" + splitedName[2] });
        }
    }

    validate(value) {
        const p = this.props;
        let error = null;
        if (!value && p.required)
            error = p.errorMsg ? p.errorMsg : p.name + ' is required';
        if (value && p.pattern) {
            let patt = new RegExp(p.pattern);
            if (!patt.test(value))
                error = p.patternErrorMsg ? p.patternErrorMsg : p.name + ' is invalid';
        }
        return error;
    }

    render() {
        const p = this.props;
        const value = this.state && this.state.value;
        const s = this.state;
        const showError = this.props.error && (value === '' || (!isNaN(value) && parseFloat(value) === 0));

        if (!s.authorized) return null;
        return (
            <div className={p.className || "form-group"}>
                <div>
                    <TextField
                        autoFocus={p.autoFocus}
                        name={p.name}
                        disabled={p.disabled}
                        underlineShow={p.underlineShow}
                        errorText={showError ? p.error : ''}
                        value={toMoney(s.value)}
                        inputStyle={p.inputStyle}
                        hintStyle={p.hintStyle}
                        label={p.floatingLabelText || p.label}
                        placeholder={p.hintText}
                        floatingLabelStyle={p.floatingLabelStyle}
                        floatingLabelText={p.floatingLabelText}
                        ref={p.ref}
                        fullWidth={p.fullWidth || false}
                        className={p.className}
                        onChange={(e) => this.onChange(e)}
                        variant='standard'
                        onBlur={(e) => this.onBlur(e)} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name],
        userAutorizationLevel: state.common && state.common.user && state.common.user.authorizationLevel,
        poproductQuantity: state.form ? state.form["productPOQuantity"] ? state.form["productPOQuantity"] : 1 : 1
    };
};

export default connect(mapStateToProps)(DecimalInputInventoryAdjust);
